import { useEffect, useState } from "react";
import { Headphones } from "lucide-react";
import { endpoints } from "@/lib/api";

const SID_KEY = "bbk_radio_sid";
const sid = () => {
  let v = sessionStorage.getItem(SID_KEY);
  if (!v) { v = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; sessionStorage.setItem(SID_KEY, v); }
  return v;
};
let shared = { n: null };
const subs = new Set();
const emit = (n) => { shared.n = n; subs.forEach((f) => f(n)); };

// Heartbeat every 30s while the radio is playing (tab visible or not — audio keeps playing).
export function useRadioHeartbeat(playing) {
  useEffect(() => {
    if (!playing) { endpoints.radioHeartbeat(sid(), false).then((r) => emit(r.data.listening)).catch(() => {}); return undefined; }
    const beat = () => endpoints.radioHeartbeat(sid(), true).then((r) => emit(r.data.listening)).catch(() => {});
    beat();
    const t = setInterval(beat, 30000);
    return () => clearInterval(t);
  }, [playing]);
}

// "N listening now" — refreshed every 30s while visible.
export function RadioListeners({ className = "", testid = "radio-listeners" }) {
  const [n, setN] = useState(shared.n);
  useEffect(() => {
    subs.add(setN);
    const load = () => { if (document.visibilityState === "visible") endpoints.radioListeners().then((r) => emit(r.data.listening)).catch(() => {}); };
    load();
    const t = setInterval(load, 30000);
    return () => { subs.delete(setN); clearInterval(t); };
  }, []);
  if (n == null) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${className}`} data-testid={testid}>
      <Headphones className="w-3.5 h-3.5 text-[#E11D2A]" />
      <span data-testid={`${testid}-count`}>{n.toLocaleString()}</span> listening now
    </span>
  );
}
